/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { MeGetMeOptions, MeGetMeResponses } from '../models/MeGetMe'
import { meGetMeResponseSchema } from '../schemas/meGetMeSchema'

/**
 * @summary Current user info + role context + UI pages. Badge numbers live in getUICounts.
 * {@link /api/v4/me/getMe}
 */
export function meGetMe<ThrowOnError extends boolean = true>(
  options: Options<MeGetMeOptions, ThrowOnError> = {}
): Unwrappable<RequestResult<MeGetMeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/api/v4/me/getMe',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: { response: meGetMeResponseSchema },
      ...config,
    }) as Promise<RequestResult<MeGetMeResponses, ThrowOnError>>
  )
}
